import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import AboutSection from "../../components/AboutComponents/AboutSection/AboutSection";
import BrandSection from "../../components/AboutComponents/BrandSection/BrandSection";
import FeatureSection from "../../components/AboutComponents/FeatureSection/FeatureSection";
import TeamSection from "../../components/AboutComponents/TeamSection/TeamSection";
import AwardSection from "../../components/AboutComponents/AwardSection/AwardSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import logo from "../../images/about/aquarlabs.png";

const AboutPage: React.FC = () => {
  return (
    <Fragment>
      <Helmet>
        <title>About Us | AquarLabs - Our Mission, Values & Leadership</title>
        <meta name="description" content="Learn about AquarLabs - our mission to empower communities through technology, our core values, and meet our founding team. We're committed to making lives better with tech." />
        <meta name="keywords" content="about AquarLabs, tech company India, AI company, mission statement, founding team, Rajesh T, Samuel M, Abhishek T, technology for good" />
        <link rel="canonical" href="https://aquarlabs.com/about" />
        <meta property="og:title" content="About Us | AquarLabs" />
        <meta property="og:description" content="Learn about AquarLabs - our mission to empower communities through technology and meet our founding team." />
        <meta property="og:url" content="https://aquarlabs.com/about" />
        <meta name="twitter:title" content="About Us | AquarLabs" />
        <meta name="twitter:description" content="Learn about AquarLabs - our mission to empower communities through technology and meet our founding team." />
      </Helmet>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            {/* Cover Photo - Full Width, Dynamic Height */}
            <div style={{
              width: "100vw",
              marginLeft: "calc(-50vw + 50%)",
              position: "relative",
              marginTop: "50px"
            }}>
              <img
                src={logo}
                alt="AquarLabs About Us"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block"
                }}
              />
            </div>
            {/* <PageTitle pageTitle="About Us" pagesub="About Us" /> */}
            <AboutSection />
            {/* <BrandSection /> */}
            {/* <FeatureSection /> */}
            <TeamSection />
            {/* <AwardSection /> */}
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default AboutPage;
